import { useCallback } from "react";
import { Country, Currency } from "@lookiero/sty-psp-locale";
import { Segment } from "@lookiero/sty-psp-segment";
import { Tradename } from "@lookiero/sty-sp-tradename";
import { Product } from "../../../domain/entities/product/Product";
import { TrackingEventName } from "./tracking";
import { useTrackBasketItem } from "./useTrackBasketItem";

interface TrackBasketItemRemovedFunctionArgs {
  readonly product: Product;
  readonly currency: Currency;
}

interface TrackBasketItemRemovedFunction {
  (args: TrackBasketItemRemovedFunctionArgs): void;
}

interface UseTrackBasketItemRemovedFunctionArgs {
  readonly country: Country;
  readonly segment: Segment;
  readonly userId: string;
  readonly tradename: Tradename;
}

interface UseTrackBasketItemRemovedFunction {
  (agrs: UseTrackBasketItemRemovedFunctionArgs): TrackBasketItemRemovedFunction;
}

const useTrackBasketItemRemoved: UseTrackBasketItemRemovedFunction = ({ country, segment, tradename, userId }) => {
  const trackBasketItem = useTrackBasketItem({
    event: TrackingEventName.BASKET_ITEM_REMOVED,
    country,
    segment,
    tradename,
    userId,
  });

  const trackBasketItemRemoved: TrackBasketItemRemovedFunction = useCallback(
    ({ product, currency }) =>
      trackBasketItem({
        product,
        currency,
      }),
    [trackBasketItem],
  );

  return trackBasketItemRemoved;
};

export { useTrackBasketItemRemoved };
